import chineseImg from "@/assets/img/lang/chineseimg.png";
import englishImg from "@/assets/img/lang/englishimg.png";
const langSource = {
  source: [
    {langType: 'zh-CN', icon: '#icon-zhongguo', label: '中文', img: chineseImg},
    {langType: 'en-US', icon: '#icon-yingguo', label: 'English', img: englishImg},
  ],
  getChineseLangType() {
    return this.source[0].langType;
  },
  getChineseLangIcon() {
    return this.source[0].icon;
  },
  getEnglishLangType() {
    return this.source[1].langType;
  },
  getEnglishLangIcon() {
    return this.source[1].icon;
  },
  getAllLangSource() {
    return this.source
  },
  getLangByType(type) {
    return this.source.find(element => element.langType === type);
  }
}
export default langSource;
